var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: { kamitaku: "", propsData: { isCurrency: true } },
            on: {
              searchChange: _vm.searchChange,
              currencyChange: _vm.currencyChange
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.tableData.length },
                  on: { click: _vm.exportTab }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addReplenishment.open()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("replenishmentOrder")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: { click: _vm.getListnew }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData && _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "sticky-table-header",
                  rawName: "v-sticky-table-header",
                  value: 0,
                  expression: "0"
                },
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              ref: "tableRef",
              attrs: { id: "tableRef", data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  "class-name": "font-bold",
                  prop: "date",
                  label: _vm.$t("date")
                }
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "login_num",
                  label: _vm.$t("activeUsers")
                }
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "recharge_num",
                  label: _vm.$t("totalPayAmount")
                }
              }),
              _vm.queryCurrency == "VND"
                ? _c("el-table-column", {
                    attrs: {
                      sortable: "",
                      prop: "recharge_numexchange",
                      label: _vm.$t("totalPayAmountUsd")
                    }
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: _vm.$t("replenishmentRecord") },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.$index + 1 < _vm.tableData.length
                            ? _c("div", { staticClass: "x-c" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "controlsBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.viewRecord(scope)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("view")))]
                                )
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1449342441
                )
              })
            ],
            1
          )
        : _vm._e(),
      _c("addReplenishment", { ref: "addReplenishment" }),
      _c(
        "el-drawer",
        {
          attrs: { size: 1600, visible: _vm.drawer },
          on: {
            "update:visible": function($event) {
              _vm.drawer = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "drawerBox" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.exportReplenishment }
                        },
                        [_vm._v(_vm._s(_vm.$t("export")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-table",
                { attrs: { data: _vm.Replenishment, border: "" } },
                _vm._l(_vm.ReplenishmentColumn, function(item, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: item.prop,
                      label: item.label,
                      width: item.width,
                      "show-overflow-tooltip": ""
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }